// Echte Kundenstimmen von YouTube. Zitate stammen aus den jeweiligen Videos.

export type Testimonial = {
  id: string;
  name: string;
  detail: string;
  quote: string;
  youtubeId: string;
};

export const testimonials: Testimonial[] = [
  {
    id: "martina-bachler",
    name: "Martina Bachler",
    detail: "Aus Innsbruck · Ein Buch über vier Generationen",
    quote: "Ich habe jetzt wirklich das Buch meines Lebens geschrieben – das Buch von vier Generationen unserer Familie.",
    youtubeId: "OdwamavFJck",
  },
  {
    id: "katharina-blum",
    name: "Katharina Blum",
    detail: "Aus dem Thurgau · Erster historischer Roman",
    quote: "Ich habe es tatsächlich geschafft: Mein erster historischer Roman ist fertig und im Verlag.",
    youtubeId: "ujvXCEdVC9I",
  },
  {
    id: "sabine-steininger",
    name: "Sabine Steininger",
    detail: "In der Schreibakademie seit 2025",
    quote: "Man geht aus jedem dieser Calls so bereichert raus.",
    youtubeId: "EXsGzKFEvCE",
  },
  {
    id: "andrea-berger",
    name: "Andrea Berger",
    detail: "Schreibt inzwischen an vier Büchern",
    quote: "Man fühlt sich nie alleine mit seinem Projekt – und das ist Gold wert.",
    youtubeId: "-bSjWiF8fsE",
  },
];
